// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pdfobject-container {\n  width: 100%;\n  margin: 0;\n}\n/* .pdfobject {\n  border: 1px solid #666;\n} */\n", ""]);
// Exports
module.exports = exports;
